import styled from 'styled-components';
import { StyleSheet } from '@react-pdf/renderer';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  background: white;
  max-width: 500px;
  margin: auto;
  border-radius: 10px;

  .container {
    max-width: 1200px;
    width: 100%;
    padding: 20px 20px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-direction: column;
  }

  header {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;

    img {
      height: 60px;
      width: auto;
      background: #446795;
    }
  }

  .logo-wrapper {
    margin: 30px;
    padding: 5px;
    position: relative;
    width: 200px;
    background: none;
  }

  footer {
    margin-top: auto;

    .tifle-logo-wrapper {
      margin: 30px;
      padding: 5px;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;

      div {
        margin-bottom: 5px;
        font-size: 11px;
      }

      img {
        width: 65px;
      }
    }
  }

  p {
    margin-top: 20px;
    text-align: justify;
  }

  .phone-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 0 5px;
  }

  input {
    max-width: 100px;
  }

  .error {
    margin-top: 20px;
    color: red;
    text-align: center;
  }
`;

export const PDFStyle = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 0,
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
  },
  section: {
    marginTop: 10,
    paddingHorizontal: 50,
  },
  halfSection: {
    marginTop: 10,
    paddingHorizontal: 50,
    flex: 1,
  },
  title: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 30,
  },
  text: {
    fontSize: 12,
    textAlign: 'justify',
    paddingVertical: 2,
  },
  image: {
    marginBottom: 10,
    width: 'auto',
    height: 50,
    textAlign: 'center',
    padding: 5,
  },
});
